export default {
  configuredOffer: {
    title: "Oferta circuitului configurat",
    subtitle:
      "Prezintă clientului camerele, îmbarcarea și serviciile alese, într-o ofertă personalizată.",
    create: "Ofertă cu selecțiile mele",
    createHint: "Poți pregăti oferta înainte de a completa datele turiștilor.",
    back: "Înapoi la configurare",
    showSuggestions: "Arată și extraopțiunile disponibile",
    switchHint:
      "Sugestiile sunt afișate separat și nu modifică totalul ofertei.",
    configuredTotal: "Circuitul tău, configurat",
    totalHint:
      "Total pentru toți turiștii, cu taxele și serviciile selectate incluse. Sugestiile opționale nu sunt incluse.",
    priceBasis:
      "Oferta reflectă camerele, punctul de îmbarcare și serviciile alese pentru turiștii de mai sus.",
    yourConfiguration: "Configurația aleasă pentru tine",
    breakdown: "Ce include tariful",
    selectedServices: "Serviciile configurației tale",
    suggestionsTitle: "Mai mult de descoperit",
    makeItYours: "Opțional · la alegerea ta",
    suggestionsHint:
      "Poți adăuga serviciile de mai jos. Sumele reprezintă costuri suplimentare pentru turiștii indicați și nu sunt incluse în totalul de mai sus.",
    notIncluded: "Opțional · neinclus în total",
    includedTotal: "Inclus în totalul configurației",
    person: "Camera {room} · turistul {person}",
    priceOnRequest: "Tarif la cerere",
    estimate:
      "Tarifele serviciilor calculate individual sunt estimative și se reconfirmă la rezervare.",
    unready:
      "Verifică selecția camerelor și a serviciilor și așteaptă finalizarea verificării tarifelor. Pentru un serviciu individual, selectează cel puțin un turist.",
    standardServices:
      "Informațiile generale ale circuitului sunt prezentate mai jos. Serviciile adăugate pentru această ofertă sunt detaliate în configurația de mai sus.",
    seats: "Locuri preferate în autocar",
    seatsHint:
      "Locurile selectate sunt preferințe și se confirmă la rezervare.",
  },
  tourOffers: {
    title: "Oferte de circuite",
    defaultTitle: "Următoarea ta călătorie începe aici",
    subtitle:
      "Transformă plecările selectate într-o propunere personalizată, gata de trimis clientului.",
    back: "Înapoi la circuite",
    selectionHint:
      "Selectează un circuit întreg sau doar datele de plecare potrivite din rezultatele căutării.",
    selectTour: "Selectează circuitul pentru ofertă",
    selectDate: "Selectează pentru ofertă",
    eligibleDates:
      "{count} plecări cu tarif disponibil, inclusiv cele la cerere",
    selected: "{count} plecări selectate pentru ofertă",
    create: "Creează oferta",
    room: "Camera {number}",
    adults: "{count} adulți",
    children: "copii — vârste: {ages} ani",
    priceBasis:
      "Tarife totale pentru toate camerele și toți turiștii de mai sus, cu taxe incluse. Fiecare plecare este o alternativă. Opțiunile suplimentare alese la rezervare pot modifica prețul.",
    tooLarge:
      "Oferta este prea mare pentru generare. Redu numărul de plecări sau lungimea textelor.",
  },

  app: {
    partners: "Portal parteneri",
    tagline: "Vacanțe frumoase. Parteneriate de încredere.",
    hello: "Hello, partener!",
    intro: "Următoarea vacanță reușită începe aici.",
    workspace: "Spațiul tău de lucru",
    copyright: "Hello Holidays · Portal pentru agenții partenere",
    support: "Alături de tine, la fiecare rezervare",
  },
  nav: {
    home: "Acasă",
    packages: "Pachete sejur",
    hotels: "Hoteluri",
    villas: "Vile",
    tours: "Circuite",
    bus: "Bilete autocar",
    bookings: "Rezervări",
    account: "Contul meu",
    contact: "Contact",
    logout: "Deconectare",
    offers: "Ofertele mele",
  },
  common: {
    search: "Caută oferte",
    loading: "Se încarcă…",
    retry: "Încearcă din nou",
    save: "Salvează",
    cancel: "Renunță",
    close: "Închide",
    remove: "Elimină",
    select: "Selectează",
    all: "Toate",
    details: "Vezi detalii",
    error: "Nu am putut finaliza solicitarea. Încearcă din nou.",
    empty: "Nu am găsit rezultate",
    emptyHint: "Încearcă o altă destinație sau alte date de călătorie.",
    reset: "Resetează",
    back: "Înapoi",
    continue: "Continuă",
    required: "Completează toate câmpurile obligatorii.",
    unavailable: "Indisponibil",
    open: "Deschide",
    language: "Limba",
    menu: "Meniu",
    selectOffer: "Selectează oferta",
  },
  auth: {
    welcome: "Bine ai revenit!",
    subtitle:
      "Conectează-te și transformă planurile clienților tăi în vacanțe.",
    client: "Cod agenție",
    username: "Utilizator",
    password: "Parolă",
    login: "Intră în cont",
    expired: "Sesiunea a expirat. Autentifică-te pentru a continua.",
    failed: "Autentificarea nu a reușit. Verifică datele și încearcă din nou.",
    partner: "Partenerul tău pentru vacanțe memorabile.",
    partnerText:
      "Destinații îndrăgite, oferte atent alese și tot ce ai nevoie pentru clienți fericiți.",
    help: "Ai nevoie de ajutor cu accesul?",
    secure: "Acces dedicat agențiilor partenere",
    restoreFailed:
      "Nu am putut verifica sesiunea. Verifică conexiunea și reîncearcă.",
  },
  search: {
    roomCount: "nicio cameră | o cameră | {count} camere",
    travellerCount: "niciun turist | un turist | {count} turiști",
    title: "Găsește vacanța potrivită",
    subtitle:
      "Mai puțin timp pentru căutare. Mai multă inspirație pentru clienții tăi.",
    destination: "Destinație",
    country: "Țară",
    resort: "Stațiune",
    area: "Zonă",
    departure: "Plecare din",
    transport: "Transport",
    flight: "Avion",
    bus: "Autocar",
    own: "Individual",
    date: "Data plecării",
    checkIn: "Check-in",
    checkOut: "Check-out",
    duration: "Durată",
    nights: "nopți",
    rooms: "Camere și turiști",
    room: "Cameră",
    adults: "Adulți",
    children: "Copii",
    age: "Vârsta copilului",
    addRoom: "Adaugă cameră",
    hotels: "Hoteluri preferate",
    allHotels: "Toate hotelurile din destinație",
    available: "Doar disponibile",
    currency: "Monedă",
    product: "Tip vacanță",
    ready: "Unde îi trimitem în vacanță?",
    readyHint: "Alege destinația, perioada și turiștii. Noi găsim opțiunile.",
    results: "{count} hoteluri găsite",
    images: "Afișează imagini",
    sort: "Sortează după",
    price: "Preț crescător",
    priceDesc: "Preț descrescător",
    hotel: "Nume hotel",
    stars: "Categorie",
    selected: "{count} oferte selectate",
    selectionHint: "Compară și pregătește o propunere personalizată.",
    searching: "Căutăm cele mai bune opțiuni…",
    datesHint: "Calendarul afișează doar plecările disponibile.",
    invalidDates: "Selectează o perioadă validă.",
    meal: "Tip masă",
    total: "Preț total",
    from: "de la",
    onRequest: "La cerere",
    confirmed: "Disponibil",
    book: "Rezervă",
    taxes: "Taxe",
    commission: "Comision",
    discount: "Reducere",
    paymentSchedule: "Scadențar",
    warnings: "Condiții",
    noDates: "Nu există plecări pentru această selecție.",
  },
  offers: {
    stays: "Pachete și hoteluri",
    title: "O propunere pe gustul clientului",
    subtitle: "Ofertele selectate, într-o prezentare clară și personalizată.",
    client: "Nume client",
    notes: "Mesaj pentru client",
    markup: "Adaos (%)",
    images: "Include fotografii",
    preview: "Previzualizează",
    pdf: "Descarcă PDF",
    print: "Tipărește",
    clear: "Golește selecția",
    empty: "Nu ai selectat încă oferte.",
    disclaimer:
      "Prețurile și disponibilitatea se reconfirmă în momentul rezervării.",
    titleLabel: "Titlul ofertei",
    defaultTitle: "Propunerea ta de vacanță",
    generated: "Ofertă pregătită de",
    invalid:
      "Oferta nu este disponibilă. Revino la căutare și selectează din nou.",
    pdfSetup:
      "Exportul PDF necesită configurarea eTrip pentru această aplicație.",
  },
  booking: {
    editDocuments: "Editează datele de contact / documente",
    gender: "Sex",
    documentNo: "Număr document",
    title: "Finalizează rezervarea",
    tourists: "Datele turiștilor",
    firstName: "Prenume",
    lastName: "Nume",
    birthday: "Data nașterii",
    titleLabel: "Titlu",
    notes: "Observații",
    terms: "Am verificat datele turiștilor și accept condițiile de rezervare.",
    confirm: "Confirmă rezervarea",
    option: "Rezervare opțională",
    success: "Rezervare înregistrată",
    reference: "Număr rezervare",
    pending: "Rezervarea este în curs. Te rugăm să aștepți.",
    uncertain:
      "Nu am primit confirmarea. Verifică lista rezervărilor înainte de a retrimite.",
    number: "Număr",
    passenger: "Titular / turist",
    date: "Data rezervării",
    travelDate: "Data călătoriei",
    status: "Status",
    paid: "Achitat",
    remaining: "Rest de plată",
    keyword: "Cuvânt cheie",
    documents: "Documente",
    voucher: "Voucher",
    contract: "Contract",
    invoice: "Factură",
    view: "Detalii rezervare",
    email: "E-mail",
    phone: "Telefon",
    noPermission: "Contul tău nu permite rezervări online.",
  },
  home: {
    eyebrow: "ÎMPREUNĂ, CREĂM VACANȚE",
    packagesText: "Sejururi cu avionul, autocarul sau transport individual.",
    hotelsText: "Hotelul potrivit pentru fiecare stil de vacanță.",
    toursText: "Itinerarii care transformă călătoriile în povești.",
    bookingsText: "Toate rezervările tale, într-un singur loc.",
    quick: "Cu ce începem astăzi?",
    inspiration: "De la prima căutare, până la plecare.",
    inspirationText:
      "Compară variante, selectează ofertele potrivite și pregătește o propunere care inspiră.",
    step1: "Descoperă",
    step1Text: "Caută destinația și perioada potrivită.",
    step2: "Personalizează",
    step2Text: "Alege exact ofertele pe care vrei să le prezinți.",
    step3: "Rezervă",
    step3Text: "Verifică detaliile și confirmă vacanța.",
  },
  account: {
    agency: "Agenția ta",
    profile: "Profil utilizator",
    company: "Denumire",
    vat: "Cod fiscal",
    address: "Adresă",
    bank: "Bancă",
    iban: "Cont bancar",
  },
  bus: {
    direction: "Tip călătorie",
    return: "Tur-retur",
    out: "Doar tur",
    in: "Doar retur",
    returnDate: "Data returului",
    dropOff: "Punct debarcare / hotel",
  },
  tourBooking: {
    back: "Înapoi la circuite",
    eyebrow: "Rezervare circuit",
    title: "Pregătește călătoria",
    travellers: "{count} turiști",
    summary: "Rezumatul rezervării",
    roomsTravellers: "Camere și turiști",
    roomsHint:
      "Compară tarifele și alege camera pentru fiecare grup de turiști. Diferențele se reflectă imediat în total.",
    departureTitle: "Punctul de plecare",
    departureHint:
      "Alege locul de îmbarcare. Costul transferului și diferența față de tariful de bază sunt afișate pentru fiecare variantă.",
    servicesTitle: "Servicii și experiențe",
    servicesHint:
      "Verifică serviciile incluse și adaugă opțiunile potrivite fiecărui turist.",
    components: "Componentele circuitului",
    supplements: "Suplimente și servicii opționale",
    contactTitle: "Contact și observații",
    contactHint:
      "Introdu numărul de telefon al turistului, disponibil la plecare și cu roaming activ. Datele sunt folosite pentru informații operative și urgențe.",
    conditions: "Condiții de rezervare",
    cancellation: "Anulare și penalizări",
    cancellationText:
      "Anularea rezervărilor se face conform termenelor din anexa contractului de comercializare a pachetelor de servicii turistice. Penalizările se aplică potrivit termenelor scadente menționate în rezervare.",
    acceptTransfers: "Am citit și accept",
    transferConditions: "Condițiile generale pentru transferuri din țară",
    noUpgrade: "Fără supliment",
    totalChange: "diferență la totalul rezervării",
    roomFare: "Tarif cameră, taxe incluse",
    departureFare: "Tarif plecare, taxe incluse",
    roomsLeft: "{count} camere rămase",
    includedPrice: "Inclus în tarif",
    baseFare: "Tarif de bază",
    roomUpgrades: "Diferențe camere",
    departureUpgrade: "Diferență punct de plecare",
    optionalExtras: "Servicii opționale",
    totalHint:
      "Taxe incluse, pentru toate camerele și toți turiștii selectați.",
    balanceDue: "Scadență sold",
    updatingSchedule: "Actualizăm scadențarul…",
    bookOption: "Rezervă ca opțiune",
    optionHint:
      "Opțiunea este disponibilă pentru plecări la cel puțin 30 de zile de azi.",
    passengerHint:
      "Completează numele conform actului de călătorie. Persoanele sub 18 ani sunt copii; vârsta se verifică la data plecării.",
    adult: "Adult",
    childAge: "Copil · {age} ani",
    ageMismatch:
      "Data nașterii trebuie să corespundă vârstei din căutare, la data plecării.",
    extraAllTravellers:
      "Tarif pentru toți turiștii. Selectează mai jos persoanele care beneficiază de serviciu.",
    extraTotal: "Tarif total pentru serviciul suplimentar.",
    noRooms: "Nu există opțiuni de cameră pentru acest grup. Reia căutarea.",
    chooseRooms:
      "Selectează o cameră disponibilă pentru fiecare grup și verifică punctul de plecare și serviciile.",
    invalid:
      "Completează datele turiștilor și telefonul, verifică vârstele și acceptă ambele seturi de condiții.",
    expired:
      "Căutarea a expirat sau tarifele, disponibilitatea ori turiștii s-au schimbat. Reia căutarea înainte de a rezerva.",
    checkFailed:
      "Nu am putut verifica ultima disponibilitate. Rezervarea nu a fost trimisă. Încearcă din nou.",
    viewBooking: "Vezi rezervarea",
    outbound: "Tur",
    inbound: "Retur",
    invoiceClient: "Client persoană fizică pentru facturare",
    address: "Adresă",
    city: "Localitate",
    perPaxEstimate:
      "Tariful serviciilor selectate per turist este estimativ; reducerile și comisionul aferent se confirmă în rezervare.",
  },
  tours: {
    amountPending: "Sumă de confirmat",
    findTour: "Găsește circuitul potrivit",
    destinations: "Destinații",
    allDestinations: "Toate țările și destinațiile",
    selectedDestinations: "{count} destinații selectate",
    areas: "Zone",
    categories: "Categorii",
    departures: "Puncte de plecare",
    selectedFilters: "{0} selectate",
    matchAll: "Toate categoriile selectate",
    allMatchHint: "Circuitul trebuie să aparțină fiecărei categorii.",
    anyMatchHint: "Circuitul poate aparține oricărei categorii selectate.",
    periodDuration: "Perioadă și durată",
    departureRangeHint:
      "Perioada se referă la data plecării circuitului. Poți lăsa oricare dintre limite necompletată.",
    departureFrom: "Prima dată de plecare",
    departureTo: "Ultima dată de plecare",
    durationDays: "Durată (zile)",
    accommodationNights: "Cazare (nopți)",
    minDuration: "Durată minimă în zile",
    maxDuration: "Durată maximă în zile",
    minAccommodation: "Număr minim de nopți",
    maxAccommodation: "Număr maxim de nopți",
    reset: "Resetează filtrele",
    invalidFilters:
      "Verifică intervalele de date, zile și nopți și vârstele turiștilor. Limita minimă nu poate depăși limita maximă.",
    optionsError:
      "Unele filtre nu s-au încărcat. Reîncearcă pentru a vedea toate opțiunile.",
    results:
      "Niciun circuit găsit | Un circuit găsit | {count} circuite găsite",
    resultsHint: "Compară plecările și tarifele pentru turiștii din căutare.",
    ready: "Ce urmează să descoperim?",
    readyHint:
      "Alege destinațiile sau explorează toate circuitele. Restrânge căutarea după tematică, perioadă și punctul de plecare.",
    days: "{count} zile",
    nights: "{count} nopți",
    partyTotal: "total pentru turiștii căutați",
    departureDates: "Date de plecare",
    allDates: "Toate cele {count} plecări",
    fewerDates: "Mai puține plecări",
    unavailable: "Indisponibil",
    unknownAvailability: "Disponibilitate neconfirmată",
    noPrice: "Preț neconfirmat",
    priceDetails: "Detalii preț",
    priceBreakdown: "Detalierea tarifului",
    includedDiscount: "Reducere deja aplicată",
    netTotal: "Total de plată agenție",
    priceHint:
      "Totalul include taxele și reducerile aplicate, pentru camerele și turiștii din căutare. Opțiunile alese la rezervare pot modifica tariful.",
    appliedDiscounts: "Reduceri aplicate",
    bookingValidity: "Perioadă de rezervare",
    travelDates: "Date de călătorie",
    noSchedule: "Scadențarul nu este disponibil pentru această plecare.",
    cancellationHint:
      "Consultă condițiile operatorului și termenele de anulare din documentele rezervării.",
    operatorTerms: "Condițiile Hello Holidays",
    previousPhoto: "Fotografia precedentă",
    nextPhoto: "Fotografia următoare",
    sort: {
      price: "Preț crescător",
      priceDesc: "Preț descrescător",
      name: "Nume circuit",
      departure: "Prima plecare",
    },
    seat: "Loc",
    seats: "Alege locurile în autocar",
    title: "Descoperă circuitele Hello",
    keyword: "Caută un circuit",
    from: "De la",
    to: "Până la",
    itinerary: "Itinerariu",
    included: "Servicii incluse",
    excluded: "Servicii neincluse",
    dates: "Plecări",
    selectDate: "Alege plecarea",
    roomType: "Tip cameră",
    departurePoint: "Punct de îmbarcare",
  },
};
